const target = document.getElementById("top");
const header = document.getElementById("header");
const main = document.getElementById("main");
const searchBox = document.getElementById("search-container");
const searchToggleBtns = document.querySelectorAll(
    '[data-toggler="search-container"]',
);
const mainDefaultPaddingClasses = ["pt-39.25", "nav:pt-46.75"];
const mainSmallHeaderPaddingClass = "pt-28";

const options = {
    // rootMargin: "0px",
    threshold: 1,
};

function splitClasses(value) {
    return (value || "")
        .split(" ")
        .filter(Boolean);
}

function hideSearchBox() {
    if (!searchBox) {
        return;
    }

    const searchIsOpen =
        searchBox.classList.contains("opacity-100") ||
        Array.from(searchToggleBtns).some(
            (btn) => btn.getAttribute("aria-expanded") === "true",
        );

    if (!searchIsOpen) {
        return;
    }

    const toggleClasses = splitClasses(
        searchToggleBtns[0]?.getAttribute("data-toggler-cls"),
    );

    toggleClasses.forEach((className, index) => {
        if (index % 2 === 0) {
            searchBox.classList.add(className);
        } else {
            searchBox.classList.remove(className);
        }
    });

    searchToggleBtns.forEach((btn) => {
        btn.setAttribute("aria-expanded", "false");
    });
}

function setMainPadding(smallHeaderIsActive) {
    if (smallHeaderIsActive) {
        main.classList.remove(...mainDefaultPaddingClasses);
        main.classList.add(mainSmallHeaderPaddingClass);
    } else {
        main.classList.remove(mainSmallHeaderPaddingClass);
        main.classList.add(...mainDefaultPaddingClasses);
    }
}

function callback(entries) {
    if (entries[0].boundingClientRect.top < 0) {
        hideSearchBox();
        setMainPadding(true);
        header.classList.add("small-header");
    } else {
        setMainPadding(false);
        header.classList.remove("small-header");
    }
}

let observerHeader = new IntersectionObserver(callback, options);
observerHeader.observe(target);

export { observerHeader };
